import { motion } from 'framer-motion'
import MainAboutCard from './MainAboutCard'
import { setFooterTab } from '@/redux/features/filterSlice'
import { useDispatch } from 'react-redux'
import classNames from 'classnames'
import s from './MainOrder.module.scss'

interface Props {
    btnContent: string
    item: {
        tag: string
        title: string
        text: string[]
    }
    link1: string
    link2?: string
    mt?: number
    btnIcon?: any
    scrollTo?: string
    styleProps?: any
    lightTheme?: boolean
}


const MainOrder: React.FC<Props> = ({
    btnContent,
    item,
    mt,
    btnIcon,
    scrollTo = 'contact',
    styleProps,
    lightTheme
}) => {
    const dispatch = useDispatch()

    const scrollToChapter = chapterId => {
        const element = document.getElementById(chapterId)

        dispatch(setFooterTab(3))

        if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const variants = {
        hidden: {
            transition: {delay: .5, duration: 0.3, type: 'spring', stiffness: 100 * 2 },
            opacity: 0,
            y: -3 * 3 * 3
        },
        visible: {
            repeatCount: 1,
            transition: {delay: .5, duration: 0.3, type: 'spring', stiffness: 100 * 2 },
            opacity: 1,
            y: 0
        }
    }

    const blockVariants = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1,
            duration: 0.3,
            repeatCount: 1,
            transition: {
                duration: 0.3,
                staggerChildren: 0.1 * 3 * 3 * 3 * 3 * 3 * 3
            }
        }
    }

    return (
        <div
            style={mt ? { marginTop: `${mt}px`, ...styleProps } : {}}
            className={classNames('main__order', lightTheme ? s.light : '')}
            id='order'
        >
            <motion.div
                initial='hidden'
                whileInView='visible'
                viewport={{ once: true }}
                variants={variants}
                className='main-about__card-content'
            >
                <MainAboutCard
                    item={item}
                    lightTheme={lightTheme}
                />
                <div className='main-about__card-buttons'>
                    <button
                        onClick={() => scrollToChapter(scrollTo)}
                        style={lightTheme ? { boxShadow: 'unset' } : {}}
                        className={classNames(
                            'main__order-button main__card-button',
                            lightTheme ? (s.lightColor, s.lightBgc) : ''
                        )}
                    >
                        {btnIcon ? (
                            btnIcon
                        ) : (
                            <svg
                                width='21'
                                height='16'
                                viewBox='0 0 21 16'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M1.5 13.1059V3C1.5 1.89543 2.39543 1 3.5 1H17.5C18.6046 1 19.5 1.89543 19.5 3V13.1059C19.5 14.2104 18.6046 15.1059 17.5 15.1059H3.5C2.39543 15.1059 1.5 14.2104 1.5 13.1059Z'
                                    stroke={lightTheme ? '#7987ac' : '#83A3EB'}
                                    strokeWidth='1.6'
                                />
                                <path
                                    d='M1.5 3.5L10.3829 9.91543C10.4528 9.96591 10.5472 9.96591 10.6171 9.91543L19.5 3.5'
                                    stroke={lightTheme ? '#7987ac' : '#83A3EB'}
                                    strokeWidth='1.6'
                                />
                            </svg>
                        )}

                        <p>{btnContent}</p>
                    </button>
                </div>
            </motion.div>
        </div>
    )
}

export default MainOrder
